import { message } from 'antd';
// import moment from 'moment';
// import { ethers } from 'ethers';

export const _message = (msg) => {
  message.success(msg);
};

export const countdown = (time, cb, end) => {
  const timer = setInterval(() => {
    time -= 1;
    cb(time);
    if (time <= 0) {
      clearInterval(timer);
      end();
    }
  }, 1000);
};

export const getSmipleAddress = (address) => {
  return address;
  // if (ethers.utils.isAddress(address)) {
  //   return (
  //     address.substring(0, 4) +
  //     '...' +
  //     address.substring(address.length - 4, address.length)
  //   );
  // } else {
  //   return address;
  // }
};

// export const getWeb3Library = (provider) => {
//   const library = new ethers.providers.Web3Provider(provider);
//   library.pollingInterval = 8000; // frequency provider is polling
//   return library;
// };
